module.exports = __webpack_public_path__ + "static/media/the_warwick_crossing_small.67cafd31.jpg";